export const containsLettersRegExp = /^((?!([A-Za-z])).)*$/g;

export const containsAllCharsExeptNumbers = /^((?!([\D])).)*$/g;
